import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import {urlBase} from "./../config/Globals";

import {Partenaires} from "./Home/Partenaires";

import CategorieFaqService from "./../service/CategorieFaq";
import FaqService from "./../service/Faq";

import maison from './../assets/images/maison.svg';
import questions from './../assets/images/questions.svg';
export const Faq = () => {
    const { idFaq } = useParams();
    const[categorieFaq, setCategorieFaq] = useState([]);
    const[loadingCategorieFaq, setLoadingCategorieFaq] = useState(1);
    const fetchCategorieFaq = async() => {
        try{
            const data = await CategorieFaqService.findAll();
            setCategorieFaq(data);
            setLoadingCategorieFaq(false);
        }catch (error){

        }
    }

    const[faq, setFaq] = useState([]);
    const[loadingFaq, setLoadingFaq] = useState(1);
    const fetchFaq = async(idFaq) => {
        if(idFaq) {
            try {
                const data = await FaqService.findAllInCateg(idFaq);
                setFaq(data);
                setLoadingFaq(false);
            } catch (error) {

            }
        }else{
            try {
                const data = await FaqService.findAll();
                setFaq(data);
                setLoadingFaq(false);
            } catch (error) {

            }
        }
    }

    useEffect(() => {
        fetchCategorieFaq();
        fetchFaq(idFaq);
    }, [idFaq]);

    return (
        <>
            <Helmet>
                <title>Foire aux questions</title>
                <meta name="description" content="Foire aux questions" />
            </Helmet>
            <main class="type">
                <section className="bg-light">
                    <div className="container px-4 pt-lg-5 pb-5 position-relative z-1">

                        <div className="row pt-lg-4">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb">
                                        <li className="breadcrumb-item-custom">
                                            <a href="/" className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">FAQ</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row g-5">

                            <div className="col-12 col-lg-5 col-xxl-3 d-flex align-items-start gap-3">
                                <img src={questions} alt="FAQ" className="flex-shrink-0 d-none d-lg-block" style={{ width: 60, height: 'auto'}} />

                                    <div className="d-flex flex-column flex-grow-1">
                                        <div className="d-flex gap-3">
                                            <img src={questions} alt="FAQ" className="d-lg-none"  style={{ width: 40, height: 'auto'}}  />
                                                <h1 className="display-5 fw-sb mb-0 text-dark">Foire aux questions</h1>
                                        </div>

                                        <div className="d-flex flex-wrap gap-2 mt-4 mb-3">
                                            {
                                                categorieFaq.map((categorie, index) => {

                                                    const isActive = idFaq == categorie.id;
                                                    return (
                                                        <a
                                                            key={categorie.id}
                                                            className={`btn btn-mini btn-outline-custom ${isActive ? 'active' : ''}`}
                                                            href={urlBase + "faq/" + categorie.id}
                                                        >
                                                            {categorie.titre}
                                                        </a>
                                                    )
                                                })
                                            }
                                        </div>

                                        <div className="mt-y">
                                            <div className="fw-b fs-6 mb-3 text-dark">
                                            <p>Si vous ne trouvez pas de réponses à vos questions :</p>
                                            </div>
                                            <a href="/contact" className="btn btn-warning">Contactez-nous</a>
                                        </div>
                                    </div>
                            </div>

                            <div className="col-12 col-lg-7 col-xxl-9">
                                <div className="d-flex flex-column gap-4">
                                    {
                                        faq.map((f, index) => {
                                            return (
                                                <div key={f.id} className="bg-white p-4 d-flex gap-4 align-items-start" style={{ '--bs-bg-opacity': '0.5' }}>
                                                    <img src={questions} alt="FAQ picto"  style={{ width: 45}} className="d-none d-lg-block mt-1" />
                                                    <div>
                                                        <h2 className="h5 fw-b text-dark mb-3">{f.titre}</h2>
                                                        <div dangerouslySetInnerHTML={{__html : f.contenu}}>

                                                        </div>
                                                        {
                                                            f.categorie.map((cat, index) => {
                                                                return (
                                                                    <span key={cat.categorie_faq_id.id} className="btn btn-outline-custom disabled text-uppercase mt-4 mb-3 d-inline-flex">{cat.categorie_faq_id.titre}</span>
                                                                )
                                                            })
                                                        }

                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <Partenaires />
            </main>
        </>
    )
}